import { createBook } from "../../../books/actions";

const addBook = (book) => {
  return async (dispatch) => {
    const response = await fetch("http://localhost:9000/books", {
      method: "POST",
      body: JSON.stringify({
        ...book,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    });
    const createdBook = await response.json();

    dispatch(createBook(createdBook));
  };
};

export default addBook;
